/* @flow */

export default class LeadOfferDefaults {
  minDaysToSell: number;
  maxDaysToSell: number;
  minDebtAmount: number;
}
